import React, { useState } from "react";
import ReviewV2 from "./ReviewV2";
import SmeHelp from "../dq/SmeHelp";

/**
 * DqRulesV2 — the v2 page shell.
 *
 * Three tabs instead of six. "Agent revisions" is gone (a revised rule stays in Review, marked
 * "✎ revised"); Dashboard / By field / Data profile are analysis views and live behind Insights, which
 * is deliberately NOT built yet — v1 already has them, and the point of this trial is whether the
 * simplified REVIEW flow works. Adding them back is a copy, not a design decision.
 */
type Tab = "review" | "help";
const TABS: { key: Tab; label: string }[] = [
  { key: "review", label: "Review" },
  { key: "help", label: "Help" },
];

export default function DqRulesV2(
  { appNm, entityId, entityLabel }: { appNm: string; entityId: string; entityLabel?: string }
) {
  const [tab, setTab] = useState<Tab>("review");
  if (!entityId) return <div style={{ padding: 24, color: "#6b7c8d" }}>Select an entity to review its rules.</div>;
  return (
    <div style={{ fontFamily: "system-ui,-apple-system,sans-serif" }}>
      <div style={{ display: "flex", gap: 18, borderBottom: "1px solid #e3e8ee", marginBottom: 14 }}>
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)}
            style={{
              all: "unset", cursor: "pointer", padding: "9px 2px", fontSize: 14,
              color: tab === t.key ? "#0E2436" : "#6b7c8d",
              fontWeight: tab === t.key ? 700 : 400,
              borderBottom: tab === t.key ? "2px solid #0e7c7b" : "2px solid transparent",
            }}>{t.label}</button>
        ))}
        <span style={{ marginLeft: "auto", alignSelf: "center", fontSize: 11, color: "#946011",
                       background: "#fbf6ea", border: "1px solid #ead9b4", borderRadius: 20, padding: "2px 10px" }}>
          v2 preview — same data as DQ Rules
        </span>
      </div>
      {tab === "review" && <ReviewV2 entityId={entityId} appNm={appNm} entityLabel={entityLabel} />}
      {tab === "help" && <SmeHelp />}
    </div>
  );
}
